import groupBy from 'lodash/groupBy';

export function tenant(state = {}, action) {
  switch (action.type) {
    case 'SET_TENANT': {
      return { id: action.payload };
    }

    default:
      return state;
  }
}

export function listData(state = {}, action) {
  switch (action.type) {
    case 'FETCH_SUBSIDIARIES_DONE': {
      const { name, rows } = action.payload;
      const data = Object.assign({}, state);
      data[name] = rows;
      return data;
    }
    case 'FETCH_LIST_DATA_INPROGRESS': {
      const { docType } = action;
      let data = { ...state };
      data[docType] = {
        isFetching: true,
      };
      // console.log('FETCH_LIST_DATA_INPROGRESS ' + docType, data);
      return data;
    }
    case 'FETCH_LIST_DATA_DONE': {
      const { docType, rows } = action;
      // console.log('FETCH_LIST_DATA_DONE', action);
      let data = { ...state };
      data[docType] = {
        isFetching: false,
        rows,
      };
      return data;
    }
    case 'FETCH_LIST_DATA_ERROR': {
      const { docType, error } = action;
      // console.log('FETCH_LIST_DATA_ERROR', action);
      let data = { ...state };
      data[docType] = {
        isFetching: false,
        error,
      };
      return data;
    }
    case 'FETCH_LIST_DATA_ARRAY_INPROGRESS': {
      return {
        isFetching: true,
      };
    }
    case 'SILENT_FETCH_LIST_DATA_ARRAY_INPROGRESS': {
      return {
        isFetching: true,
        isSilentRefresh: true,
      };
    }
    case 'FETCH_LIST_DATA_ARRAY_ERROR': {
      const { error } = action;
      // console.log('FETCH_LIST_DATA_ARRAY_ERROR', error)
      return {
        error: error,
      };
    }
    case 'FETCH_LIST_DATA_ARRAY_DONE': {
      // console.log('FETCH_LIST_DATA_ARRAY_DONE', action)
      const { rows } = action;
      const grouped = groupBy([...rows], 'doc_type');
      const ids = groupBy(rows, (row) => row.id || row._id);
      return {
        doctype: { ...grouped },
        docid: { ...ids },
      };
    }
    case 'FETCH_LIST_DATA_ARRAY_WITH_ID_DONE': {
      const { docId, rows } = action;
      // console.log('FETCH_LIST_DATA_ARRAY_WITH_ID_DONE', action);
      const grouped = groupBy(rows, 'doc_type');
      const ids = groupBy(rows, 'id');
      return {
        doctype: grouped,
        docid: ids,
        maindata: ids[docId][0],
        isFetching: false,
      };
    }
    case 'CLEAR_FORM_MESSAGES': {
      return clearMessages(state);
    }
    default: {
      return state;
    }
  }
}

export function dataById(state = {}, action) {
  switch (action.type) {
    case 'FETCH_DATA_BY_ID_INPROGRESS': {
      let newState = { isFetching: true };
      return newState;
    }
    case 'FETCH_DATA_BY_ID_DONE': {
      const { data, message, isCopy } = action;
      let newState = { data: { ...data }, message, isCopy };
      return newState;
    }
    case 'SHOW_MESSAGE_DATA_BY_ID': {
      return { ...state, message: action.payload }
    }
    case 'FETCH_DATA_BY_ID_ERROR': {
      // console.log('FETCH_DATA_BY_ID_ERROR', action.error);
      return { error: action.error };
    }
    case 'CLEAR_FORM_MESSAGES': {
      return clearMessages(state);
    }
    case 'CLEAR_DATA_BY_ID': {
      return {};
    }
    default: {
      return state;
    }
  }
}

export function deleteRecord(state = {}, action) {
  switch (action.type) {
    case 'DELETE_RECORD_INPROGRESS': {
      return { isDeleting: true };
    }
    case 'DELETE_RECORD_DONE': {
      const { id, docType } = action.payload;
      return { id, docType };
    }
    case 'DELETE_RECORD_ERROR': {
      console.log('DELETE_RECORD_ERROR', action.error);
      return { error: action.error };
    }
    case 'CLEAR_FORM_MESSAGES': {
      return clearMessages(state);
    }
    default: {
      return state;
    }
  }
}

function clearMessages(state) {
  const newState = { ...state };
  delete newState.error;
  delete newState.message;
  delete newState.isNew;
  return newState;
}

export function listDataBySubId(state = {}, action) {
  switch (action.type) {
    case 'FETCH_LIST_DATA_BY_SUBID_DONE': {
      return { ...action.payload, isFetching: false };
    }
    case 'FETCH_LIST_DATA_BY_SUBID_INPROGRESS': {
      const { docType } = action;
      const data = { ...state, [docType]: { isFetching: true } };
      return data;
    }
    default: {
      return state;
    }
  }
}

export function saveAsRecord(state = {}, action) {
  const { result, message } = action;
  switch (action.type) {
    case 'SAVE_AS_RECORD_INPROGRESS': {
      return { isSaving: true };
    }
    case 'SAVE_AS_RECORD_DONE': {
      return { data: result, message: message };
    }
    case 'SAVE_AS_RECORD_ERROR': {
      return { isSaving: false, error: action.error };
    }
    case 'CLEAR_FORM_MESSAGES': {
      return clearMessages(state);
    }
    default: {
      return state;
    }
  }
}

export function saveRecord(state = {}, action) {
  const { result, message } = action;
  switch (action.type) {
    case 'SAVE_RECORD_INPROGRESS': {
      return { isSaving: true };
    }
    case 'SAVE_RECORD_DONE': {
      if (result) {
        return { data: result, message: message };
      }
      return { message };
    }
    case 'SAVE_RECORD_NEW_DONE': {
      return { data: result, isNew: true };
    }
    case 'SAVE_RECORD_ERROR': {
      return { isSaving: false, error: action.error };
    }
    case 'CLEAR_FORM_MESSAGES': {
      return clearMessages(state);
    }
    case 'CLEAR_SAVE_RECORD': {
      return {};
    }
    default: {
      return state;
    }
  }
}

export function listItemLocByItemId(state = {}, action) {
  switch (action.type) {
    case 'FETCH_LIST_ITEM_LOC_BY_ITEMID_DONE': {
      return { ...action.payload, isFetching: false };
    }
    case 'FETCH_LIST_ITEM_LOC_BY_ITEMID_INPROGRESS': {
      const { docType } = action;
      const data = { ...state, [docType]: { isFetching: true } };
      return data;
    }
    default: {
      return state;
    }
  }
}

export function dropdownList(state = {}, action) {
  switch (action.type) {
    case 'FETCH_DROPDOWN_LIST_DONE': {
      return {
        ...state,
        [action.id]: {
          list: action.list,
          searchTerm: action.searchTerm,
        },
      };
    }
    case 'FETCH_DROPDOWN_LIST_INPROGRESS': {
      const currentList = (state[action.id] && state[action.id].list) || [];
      return {
        ...state,
        [action.id]: {
          isFetching: true,
          list: [...currentList],
        },
      };
    }
    case 'FETCH_DROPDOWN_LIST_ERROR': {
      return {
        ...state,
        [action.id]: {
          error: action.error,
        },
      };
    }
    case 'CLEAR_DROPDOWN': {
      return {
        ...state,
        [action.id]: {
          isCleared: true,
          list: state[action.id].list,
        },
      };
    }
    default: {
      return state;
    }
  }
}

const singleQueryInitialState = { result: false };
export function singleQueryResult(state = singleQueryInitialState, action) {
  switch (action.type) {
    case 'SINGLE_QUERY_RESULT': {
      return {
        ...state,
        result: action.payload,
      };
    }
    default:
      return state;
  }
}
